import { useMemo } from 'react';
import { IGamesCategory, IGamesCategoryWidget } from '../../../types';
import { getGames } from '../../../utils';
import { useGamesData } from '../useGamesData';

export const useWidgetGamesCategory = (categories: IGamesCategory[]) => {
  const gamesData = useGamesData();

  return useMemo<IGamesCategoryWidget[]>(
    () =>
      categories
        .map(({ id, games: categoryGames, ...rest }) => {
          return {
            id,
            categoryGames: getGames(categoryGames, gamesData),
            ...rest
          };
        })
        .filter(({ categoryGames }) => categoryGames.length > 0),
    [categories, gamesData]
  );
};
